// import { Switch } from "@radix-ui/themes";
import { Switch } from "@mui/material";
import { useState } from "react";

interface UiSwitchProps {
  label?: string;
  className?: string;
  defaultValue?: boolean;
  onChange?: () => void;
}
export function UiSwitch({
  label,
  className,
  defaultValue,
  onChange,
}: UiSwitchProps) {
  const [value, setValue] = useState<boolean>(
    defaultValue !== undefined ? defaultValue : false
  );
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.checked);
    if (onChange) onChange();
  };
  return (
    <div className={`flex ${className || ""}`}>
      {label && <label className="ui-form-label">{label}</label>}
      <Switch
        size="medium"
        color="primary"
        checked={value}
        onChange={handleChange}
      />
    </div>
  );
}
